/**
 * @license lucide v0.294.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const AlignLeft = [
  "svg",
  defaultAttributes,
  [
    ["line", { x1: "21", x2: "3", y1: "6", y2: "6" }],
    ["line", { x1: "15", x2: "3", y1: "12", y2: "12" }],
    ["line", { x1: "17", x2: "3", y1: "18", y2: "18" }]
  ]
];

export { AlignLeft as default };
//# sourceMappingURL=align-left.js.map
